import React, { useState } from 'react';
import { Snowflake, Droplet, User } from 'lucide-react';
import EstoqueDeSemen from '../shared/EstoqueDeSemen';
import EstoqueDeCongelados from '../shared/EstoqueDeCongelados';
import EstoquePorCliente from '../shared/EstoquePorCliente';

/**
 * Estoque: o que está guardado no nitrogênio.
 *
 * Aba própria, e não uma seção dentro de Laboratório, porque são coisas de
 * naturezas diferentes. Laboratório é configuração — mexe-se uma vez e
 * esquece. Estoque é consulta de rotina: antes de agendar uma FIV se olha
 * quanta palheta resta, e antes de prometer embrião a um cliente se olha o que
 * há no botijão. Enterrado em configurações, ninguém abre.
 *
 * As duas seções juntas porque respondem à mesma pergunta física — "o que tem
 * no botijão" — e porque dividem o mesmo vocabulário de localização.
 */
/*
 * As duas primeiras são por MATERIAL; a terceira é por DONO.
 *
 * Embriões e sêmen são listas de naturezas diferentes — cada uma agrupa do seu
 * jeito, e as duas carregam o endereço do botijão, que é o que serve para ir
 * buscar. Nenhuma das duas responde "o que é do fulano", que é a pergunta que
 * chega por telefone: quem atendia abria as duas e cruzava os nomes de cabeça.
 *
 * Por cliente fica por último porque é consulta, e não trabalho de bancada: as
 * duas de cima é que têm seleção, lançamento de entrada e de saída.
 */
const ABAS = [
  { id: 'congelados', nome: 'Embriões congelados', icone: Snowflake },
  { id: 'semen',      nome: 'Sêmen',               icone: Droplet },
  { id: 'cliente',    nome: 'Por cliente',         icone: User },
];

const EstoqueTab = ({ currentLab, userRole, isSuperAdmin = false, clients = [] }) => {
  const [aba, setAba] = useState('congelados');

  /**
   * Quem mexe no estoque é quem mexe no botijão.
   *
   * Estava restrito a `admin`, e por isso a tela de lançar sêmen não aparecia
   * para moderador nem para técnico — justamente as pessoas que abrem o
   * botijão. Quem guarda a palheta é quem sabe onde ela ficou.
   *
   * Mesmo conjunto de `canManageServices` no FIVSystem: só `viewer` fica de
   * fora, que é o papel feito para olhar.
   */
  const podeMexer = isSuperAdmin
    || ['admin', 'moderator', 'technician'].includes(userRole);

  if (!currentLab) {
    return (
      <div className="bg-white border border-slate-200 rounded-lg px-6 py-10 text-center">
        <p className="text-slate-600 text-sm">Selecione um laboratório.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex gap-1 border-b border-slate-200 overflow-x-auto">
        {ABAS.map(({ id, nome, icone: Icone }) => (
          <button key={id} onClick={() => setAba(id)}
            className={`flex items-center gap-1.5 px-3 py-2 text-sm border-b-2 -mb-px transition-colors ${
              aba === id
                ? 'border-blue-600 text-slate-900 font-medium'
                : 'border-transparent text-slate-500 hover:text-slate-700'}`}>
            <Icone size={15} /> {nome}
          </button>
        ))}
      </div>

      {aba === 'congelados' && <EstoqueDeCongelados laboratoryId={currentLab.id} clients={clients} podeMexer={podeMexer} />}
      {aba === 'semen'      && <EstoqueDeSemen laboratoryId={currentLab.id} clients={clients} podeMexer={podeMexer} />}
      {aba === 'cliente'    && <EstoquePorCliente currentLab={currentLab} clients={clients} />}
    </div>
  );
};

export default EstoqueTab;
